var chopstickBarcode = function () {
    var item = $('.js-barcode');
    var barcode;

    item.each(function () {
        barcode = $(this).data('code');
        if (barcode) {
            $(this).JsBarcode(barcode, {
                lineColor: '#175b82',
                height: 40,
                font: 'soleil',
                fontSize: 18,
                textAlign: 'left',
                margin: 0
            });
        }
    });
};
